import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import DataTable from "react-data-table-component";
import {connect} from "react-redux";
import {toast} from "react-toastify";
import {CustomerCustomersList} from "../../../redux/actions/Modules.Action";
import ApiConnect from "../../../Utils/ApiConnect";
import DispatchLabel from "./Components/DispatchLabel";
import OrderDetils from "./Components/OrderDetils";

// import { Link } from "react-router-dom";
class Dispatch extends Component {
  constructor(props) {
    super(props);
this.state = {
      BookingData: [],
      showModal: false,
      modalView: false,
      selectedId: false,
      filterText: "",
    };
    this.columns = [
      {
        name: "Booking ID",
        selector: row => row.id,
        cell: (row) => {
          return (
            <a
              href="#_"
              onClick={() => {
                this.setState({
                  showModal: true,
                  modalView: <OrderDetils BookingDetails={row} />,
                });
              }}
            >
              {row.id}
            </a>
          );
        },
      },
      {
        name: "Date",
        selector: row => row.date,
        sortable: true,
      },
      {
        name: "Total Items",
        selector: row => row.total_items,
        sortable: true,
      },
      {
        name: "Total Amount",
        selector: row => row.total_amount,
      },
      {
        name: "Payment",
        selector: row => row.payment,
        sortable: true,
      },
      {
        name: "Order Att",
        selector: row => row.user,
        cell: (row) => {
          return (
            <div className="avatar-list avatar-list-overlap">
              <a className="avatar" href="#_">
                <img src={row.user.avatar} alt={row.user.name} />
              </a>
              <a className="avatar" href="#_">
                <img
                  src={row.assign_by.avatar}
                  alt={row.assign_by.name}
                />
              </a>
              <a className="avatar avatar-lg" href="#_">
                <img src={row.agent.avatar} alt={row.user.name} />
              </a>
            </div>
          );
        },
      },

      {
        name: "Action",
        selector: row => row.action,
        className: "table-actions",
        sortable: false,
        cell: (row, id) => {
          return (
            <React.Fragment key={id}>
              <button
                className="table-action btn btn-square btn-pure hover-success"
                onClick={() => {
                  this.cashReceive(row.id);
                }}
              >
                <span className="material-icons-outlined fs-35">local_atm</span>
              </button>
              <button
                className="table-action btn btn-square btn-pure hover-warning"
                onClick={() => {
                  this.setState({
                    showModal: true,
                    modalView: <DispatchLabel BookingDetails={row} />,
                  });
                }}
              >
                <span className="material-icons-outlined fs-35">print</span>
              </button>
            </React.Fragment>
          );
        },
      },
      ];
  }

  customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  componentDidMount() {
    this.fetchCustomer();
  }
  fetchCustomer() {
    ApiConnect.get("/Module/Booking/Main/DispatchDetails")
      .then((response) => {
        this.setState({ BookingData: response.data });
      })
      .catch((error) => console.log(error));
  }
  cashReceive(e) {
    ApiConnect.put(`/Module/Booking/Main/PaymentReceive?id=${e}`)
      .then((response) => {
        if (response.data.status === 201) {
          this.fetchCustomer();
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  render() {
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Order Dispatch</strong>
                </h2>
              </div>
            </div>
            <div className="header-action"></div>
          </header>
          <div className="card-body">
            <div className="dataTables_wrapper">
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  onChange={e => this.setState({ filterText: e.target.value })}
                />
              </div>
              <DataTable
                className="table table-separated"
                keyField="id"
                columns={this.columns}
                data={this.state.BookingData.filter(item =>
                  Object.values(item).some(val =>
                    String(val).toLowerCase().includes(this.state.filterText.toLowerCase())
                  )
                )}
                pagination
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                paginationPerPage={10}
                customStyles={this.customStyles}
                filter
                exportable
              />
            </div>
          </div>
          <Modal
            show={this.state.showModal}
            className="modal-center"
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Dialog>
              <Modal.Header>
                <h5 className="modal-title">Quick Preview</h5>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.setState({ showModal: false })}
                >
                  <span className="material-icons-outlined">close</span>
                </button>
              </Modal.Header>
              {this.state.modalView}
            </Modal.Dialog>
          </Modal>
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    CustomerList: state.Customer.CustomerList,
  }),
  { CustomerCustomersList }
)(Dispatch);
